<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Payout Field Setup</div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form v-model="valid" ref="filter">
            <v-row class="ma-0 ms-0">
              <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  v-model="searchfilter.pay_country"
                  class="rounded mb-2"
                  dense
                  outlined
                  hide-details
                  label="Payout Country"
                  item-text="txt"
                  item-value="val"
                  :items="countryOptions"
                  :rules="FieldRequired('Payout Country')"
                  @input="getCountrypaymentModes(searchfilter.pay_country)"
                  placeholder="Payout Country"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  v-model="searchfilter.payment_mode"
                  class="rounded mb-2"
                  dense
                  outlined
                  hide-details
                  label="Payment Mode"
                  item-text="txt"
                  item-value="val"
                  :items="paymentModesList"
                  :rules="FieldRequired('Payment Mode')"
                  placeholder="Payment Mode"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="3">
                <v-autocomplete
                  v-model="searchfilter.txn_type"
                  class="rounded mb-2"
                  dense
                  outlined
                  hide-details
                  label="Txn Type"
                  :items="user_types"
                  :rules="FieldRequired('Txn Type')"
                  placeholder="Select Txn Type"
                ></v-autocomplete>
              </v-col>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-1 text-decoration-none"
                color="primary"
                @click="getAllfieldSetups()"
                >Get Results</v-btn
              >
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="dessertHeaders"
        :items="fieldSetups"
        :search="search"
        dense
        show-select
        v-model="selectedData"
        item-key="id"
      >
        <template v-slot:item.field_id_param_data="{ item }">
          <span>{{
            item.field_id_param_data && item.field_id_param_data.value
          }}</span>
        </template>
        <template v-slot:item.min_field_length="{ item }">
          <v-text-field
            v-model="item.min_field_length"
            class="rounded ma-1"
            type="number"
            hide-spin-buttons
            dense
            outlined
            title="Min Length"
            hide-details
            placeholder="Min Length"
            :rules="FieldNumbRequired('Min length')"
          ></v-text-field>
        </template>
        <template v-slot:item.is_dropdown="{ item }">
          <v-checkbox v-model="item.is_dropdown"></v-checkbox>
        </template>
        <template v-slot:item.is_field_required="{ item }">
          <v-checkbox v-model="item.is_field_required"></v-checkbox>
        </template>
        <template v-slot:item.max_field_length="{ item }">
          <v-text-field
            v-model="item.max_field_length"
            class="rounded ma-1"
            type="number"
            title="Max Length"
            hide-spin-buttons
            dense
            outlined
            hide-details
            placeholder="Max Length"
            :rules="FieldNumbRequired('Max Length')"
          ></v-text-field>
        </template>
        <template v-slot:item.alias_name="{ item }">
          <v-text-field
            v-model="item.alias_name"
            class="rounded"
            hide-spin-buttons
            dense
            outlined
            hide-details
            title="Alias Name"
            placeholder="Field Alias Name"
            :rules="FieldNumbRequired('Alias Name')"
          ></v-text-field>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-switch
              dense
              class="mt-6"
              @change="updateStatus(item)"
              v-model="item.is_active"
            >
            </v-switch>
            <v-icon
              small
              title="Update"
              color="primary"
              class="mr-2"
              @click="UpdateSetupData(item)"
            >
              mdi-content-save-edit-outline
            </v-icon>
          </div>
        </template>

        <template v-slot:top>
          <div class="d-flex mt-3">
            <v-btn
              depressed
              small
              class="text-capitalize me-2 ms-2 mt-2 text-decoration-none"
              color="primary"
              @click="openDialog()"
              ><v-icon small>mdi-plus</v-icon>Add</v-btn
            >
            <v-btn
              depressed
              small
              class="text-capitalize me-2 ms-2 mt-2 text-decoration-none"
              color="primary"
              @click="UpdateSetupData()"
              ><v-icon small> mdi-content-save-edit-outline</v-icon>Update
              All</v-btn
            >
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              color="primary"
              small
              class="me-5 mt-2"
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-3"
              dense
              clearable
            ></v-text-field>
          </div>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showDialog" width="500">
        <v-card>
          <v-form ref="Addform" v-model="valid">
            <v-toolbar color="#050048" dark flat dense>
              <span>{{ formtitle }} Payout Fields</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12"
                  ><label class="my-0 labelFontsize required">
                    Payout Country
                  </label>
                  <v-autocomplete
                    v-model="fieldSetupDetails.country_code"
                    class="rounded"
                    dense
                    outlined
                    placeholder="Select Payout Country"
                    item-text="txt"
                    item-value="val"
                    :items="countryOptions"
                    :rules="FieldRequired('Payout Country')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12"
                  ><label class="my-0 labelFontsize required"> Txn Type </label>
                  <v-autocomplete
                    v-model="searchfilter.txn_type"
                    class="rounded"
                    dense
                    outlined
                    :items="user_types"
                    placeholder="Select Txn Type"
                    :rules="FieldRequired('Txn Type')"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12"
                  ><label class="my-0 labelFontsize required">
                    Payment Mode
                  </label>
                  <v-autocomplete
                    v-model="fieldSetupDetails.payment_method"
                    class="rounded"
                    dense
                    outlined
                    placeholder="Select Payment Mode"
                    item-text="txt"
                    item-value="val"
                    :rules="FieldRequired('Payment Mode')"
                    :items="paymentModesList"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12"
                  ><label class="my-0 labelFontsize required">
                    Payout Fields
                  </label>
                  <v-autocomplete
                    v-model="fieldSetupDetails.keyword_list"
                    class="rounded"
                    dense
                    outlined
                    placeholder="Select Payout Fields"
                    multiple
                    :items="partnerFields"
                    :rules="FieldRequired('Payout Fields')"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="pa-0 mb-0"></v-divider>
            <v-card-actions class="ma-0 pt-0">
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                @click="submitData()"
                ><v-icon small>mdi-content-save-plus-outline</v-icon>Submit
              </v-btn>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                outlined
                @click="closeDialog()"
                ><v-icon small>mdi-close</v-icon>cancel
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import setupService from "@/services/SetupService/setupService.js";
import commonService from "@/services/CommonService/commonService.js";
import { FieldRequired, FieldNumbRequired } from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  name: "Master Bank Summary",
  data() {
    return {
      searchfilter: {
        pay_country: "",
        payment_mode: "",
        txn_type: "",
      },
      FieldRequired,
      FieldNumbRequired,
      filterNumberInput,
      search: "",
      loader: false,
      showDialog: false,
      showRateDialog: false,
      selcted_rate_id: null,
      valid: true,
      editedIndex: -1,
      countryOptions: [],
      partnerFields: [],
      selectedData: [],
      paymentModesList: [],
      payoutPartner: [],
      dropdown: {
        country_objs: [],
      },
      user_types: [
        {
          text: "Individual",
          value: "IND",
        },
        {
          text: "Business",
          value: "BUS",
        },
      ],
      fieldSetups: [],
      fieldSetupDetails: {
        country_code: "",
        payment_method: "",
        txn_type: "",
        partner_id: null,
        field_id_param: "PRF",
        keyword_list: [],
      },
      update_cost_rate: {
        cost_rate: 0,
        ho_margin: 0,
        settlement_rate: 0,
        agent_margin: 0,
        txn_rate: 0,
      },
    };
  },
  components: {
    OverlayPageVue,
  },
  watch: {},
  mounted() {
    this.getcountryList();
    this.getparamterFields();
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
    dessertHeaders() {
      return [
        {
          text: "Id",
          sortable: false,
          value: "id",
        },
        {
          text: "Field Name",
          width: "190px",
          value: "field_id_param_data",
          sortable: false,
        },
        {
          text: "Keyword",
          value: "keyword",
          sortable: false,
          width: "100px",
        },
        {
          text: "Alias Name",
          value: "alias_name",
          sortable: false,
          width: "200px",
        },
        {
          text: " Field required",
          value: "is_field_required",
          sortable: false,
          width: "120px",
        },
        {
          text: "Min Length",
          value: "min_field_length",
          sortable: false,
          width: "140px",
        },
        {
          text: "Max Length",
          value: "max_field_length",
          sortable: false,
          width: "140px",
        },
        {
          text: "is dropdown",
          value: "is_dropdown",
          sortable: false,
          width: "120px",
        },
        {
          text: "Created Date",
          value: "created_date",
          sortable: false,
        },
        {
          text: "Created by",
          value: "created_by",
          sortable: false,
        },
        {
          text: "Actions",
          value: "action",
          sortable: false,
          width: "100px",
        },
      ];
    },
  },
  methods: {
    async getAllfieldSetups() {
      const validate = this.$refs.filter.validate();
      if (validate) {
        this.loader = true;
        try {
          const response = await setupService.getAllPayoutSetup({
            country_code: this.searchfilter.pay_country,
            payment_mode: this.searchfilter.payment_mode,
            txn_type: this.searchfilter.txn_type,
          });
          if (response.data.status_code === 200) {
            this.fieldSetups = response.data.data;
            this.stoploader();
          } else {
            this.fieldSetups == [];
            this.stoploader();
          }
        } catch (error) {
          this.fieldSetups = [];
          this.stoploader();
          console.error(error);
        }
      }
    },
    async getparamterFields() {
      try {
        const responseData = await commonService.getparameterdropdowns("PRF");
        if (responseData.data.status_code === 200) {
          this.partnerFields = responseData.data.data.map((i) => {
            return { text: i.value, value: i.value_code };
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    submitData() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.fieldSetupDetails.id) {
          this.update();
        } else {
          this.save();
        }
      }
    },
    async save() {
      try {
        const response = await setupService.addpayoutFieldStup(
          this.fieldSetupDetails
        );
        if (response.data.status_code === 200) {
          this.showAlertSuccess(response.data.message);
          this.showDialog = false;
          this.getAllfieldSetups();
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async updateStatus(item) {
      this.loader = true;
      try {
        const response = await setupService.updatepayoutFieldStupStatus({
          id: item.id,
          is_active: item.is_active,
        });
        if (response.data.status_code === 200) {
          this.showAlertSuccess(response.data.message);
          this.stoploader();
          this.getAllfieldSetups();
        } else {
          this.showAlertError(response.data.message);
          this.stoploader();
        }
      } catch (error) {
        console.error(error);
        this.stoploader();
      }
    },

    async UpdateSetupData() {
      if (this.fieldSetups.length > 0 && this.selectedData.length > 0) {
        this.loader = true;
        const payloadData = this.selectedData.map((ele) => {
          return {
            id: ele.id,
            is_field_required: ele.is_field_required,
            is_dropdown: ele.is_dropdown,
            min_field_length:
              ele.min_field_length && ele.min_field_length != ""
                ? ele.min_field_length
                : null,
            max_field_length:
              ele.max_field_length && ele.max_field_length != ""
                ? ele.max_field_length
                : null,
            alias_name: ele.alias_name,
            is_active: ele.is_active,
          };
        });
        try {
          const response = await setupService.updatepayoutFieldStup(
            payloadData
          );
          if (response.data.status_code === 200) {
            this.showAlertSuccess(response.data.message);
            this.selectedData = [];
            this.stoploader();
            this.getAllfieldSetups();
          } else {
            this.showAlertError(response.data.message);
            this.stoploader();
          }
        } catch (error) {
          console.error(error);
          this.stoploader();
        }
      }
    },

    async getcountryList() {
      try {
        const response = await setupService.getCountrysetupList();
        if (response.status === 200) {
          this.countryOptions = response.data.data.map((i) => {
            return { txt: i.name, val: i.iso_alpha3 };
          });
        }
        this.dropdown.country_objs = response.data.data;
        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.countryOptions = [];
      }
    },

    async getCountrypaymentModes(country_code) {
      try {
        const responseData = await setupService.getpaymentmodeBycntry(
          country_code
        );
        if (responseData.data.status_code === 200) {
          this.paymentModesList = responseData.data.data.map((i) => {
            return {
              txt: i.payment_type.payment_mode,
              val: i.payment_type.payment_mode_code,
            };
          });
        }
        console.log("Partners", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.fieldSetups) {
        this.exportToExcel(
          this.dessertHeaders,
          this.fieldSetups,
          "Payout Field Setups"
        );
      }
    },
    openDialog() {
      this.editedIndex = -1;
      this.showDialog = true;
      this.resetfieldSetupDetailsObj();
      if (this.$refs.Addform) {
        this.$refs.Addform.resetValidation();
      }
      this.getCountrypaymentModes(this.searchfilter.pay_country);
      if (this.searchfilter.pay_country) {
        this.fieldSetupDetails.country_code = this.searchfilter.pay_country;
        this.fieldSetupDetails.payment_method = this.searchfilter.payment_mode;
        this.fieldSetupDetails.txn_type=this.searchfilter.txn_type
      }
    },
    resetfieldSetupDetailsObj() {
      this.fieldSetupDetails.id = null;
      this.fieldSetupDetails.country_code = "";
      this.fieldSetupDetails.payment_method = "";
      this.fieldSetupDetails.keyword_list = [];
      this.fieldSetupDetails.txn_type = "";
    },

    closeRateDialog() {
      this.showRateDialog = false;
      this.$refs.AddRateform.resetValidation();
    },
    closeDialog() {
      this.showDialog = false;
      this.$refs.Addform.resetValidation();
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";

.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
